import { DeepReadonlyObject } from 'rxdb';

import { LegView, TripTypeEnum } from '@mopla/data-models';
import { getLegDuration, getTripType } from '@mopla/utils';

import { IVehicleIconProps } from '../../../icons/Vehicles/types';

type TVehicleIconLabel = Pick<IVehicleIconProps, 'mode' | 'vehicleType'>;

export interface IRideHailingServiceLabel extends TVehicleIconLabel {
	durationMin?: number;
	route?: string;
}

export const deriveRideHailingLabels = (
	legs: DeepReadonlyObject<LegView[]>
): IRideHailingServiceLabel[] => {
	const tripType = getTripType(legs);

	if (tripType === 'KRK') {
		return [{ mode: TripTypeEnum.LBODTFLEX }, { mode: TripTypeEnum.LBT }];
	}

	return legs
		.filter((leg) => leg.mode !== TripTypeEnum.TRANSFER_WALK)
		.map((leg) => ({
			mode: leg.mode,
			vehicleType: leg.vehicleType,
			route: leg.route,
			durationMin:
				leg.mode === TripTypeEnum.WALK ? getLegDuration(leg) : undefined,
		}));
};
